<ng-container *ngFor="let m of ie.Messages">
  <div class="alert alert-danger col-form-label-sm" 
       role="alert" 
       *ngIf="m.messageID == FORM_MESSAGE.RequiredMessageID && 
                             (!formgroup.controls[ie.InterfaceElementID].pristine || 
                             formgroup.controls[ie.InterfaceElementID].touched) &&
                             formgroup.controls[ie.InterfaceElementID].hasError('required') && 
                             (formgroup.controls[ie.InterfaceElementID].value == '00000000-0000-0000-0000-000000000000' || 
                             formgroup.controls[ie.InterfaceElementID].value == '')">
        {{m.messageText.replace('[label]',ie.PreLabel.DisplayName)}}
  </div>
  <div class="alert alert-danger col-form-label-sm" 
       role="alert" 
       *ngIf="m.messageID == FORM_MESSAGE.Index0MessageID && 
              (!formgroup.controls[ie.InterfaceElementID].pristine ||
              formgroup.controls[ie.InterfaceElementID].touched) && 
              (!formgroup.controls[ie.InterfaceElementID].hasError('required') &&
              formgroup.controls[ie.InterfaceElementID].hasError('index0'))">
        {{m.messageText.replace('[label]',ie.PreLabel.DisplayName)}}
  </div>
  <div class="alert alert-danger col-form-label-sm" 
       *ngIf="m.messageID == FORM_MESSAGE.NumericValidatorMessageID && 
             !formgroup.controls[ie.InterfaceElementID].pristine  && 
             formgroup.controls[ie.InterfaceElementID].hasError('numericDT') && 
             (ie.Values.length > 0 && !ie.Values[0].nil)">
        {{m.messageText.replace('[label]',ie.PreLabel.DisplayName)}}
  </div>
  <div class="alert alert-danger col-form-label-sm" 
       *ngIf="m.messageID == FORM_MESSAGE.PatternValidatorMessageID && 
              !formgroup.controls[ie.InterfaceElementID].pristine  && 
              formgroup.controls[ie.InterfaceElementID].hasError('mask') && 
              (ie.Values.length > 0  && !ie.Values[0].nil)">
        {{m.messageText.replace('[label]',ie.PreLabel.DisplayName).replace('[maskValue]',ie.Attributes.Mask.Pattern)}}{{ie.Value}}
  </div>
  <div class="alert alert-danger col-form-label-sm" 
             *ngIf="m.messageID == FORM_MESSAGE.MinValidatorMessageID && 
             !formgroup.controls[ie.InterfaceElementID].pristine  && 
             formgroup.controls[ie.InterfaceElementID].hasError('minimum') && 
             (ie.Values.length > 0  && !ie.Values[0].nil)">
        {{m.messageText.replace('[label]',ie.PreLabel.DisplayName).replace('[min]',ie.Attributes.Min)}}
  </div>
  <div class="alert alert-danger col-form-label-sm" 
       *ngIf="m.messageID == FORM_MESSAGE.MaxValidatorMessageID && 
       !formgroup.controls[ie.InterfaceElementID].pristine  && 
       formgroup.controls[ie.InterfaceElementID].hasError('maximum') && 
       (ie.Values.length > 0  && !ie.Values[0].nil)">
        {{m.messageText.replace('[label]',ie.PreLabel.DisplayName).replace('[max]',ie.Attributes.Max)}}
  </div>
  <div class="alert alert-danger col-form-label-sm" 
       *ngIf="m.messageID == FORM_MESSAGE.DateValidatorMessageID && 
        !formgroup.controls[ie.InterfaceElementID].pristine  && 
        formgroup.controls[ie.InterfaceElementID].hasError('dateDT') && 
        (ie.Values.length > 0  && !ie.Values[0].nil)">
    {{m.messageText.replace('[label]',ie.PreLabel.DisplayName)}}
  </div>
</ng-container>

